import { MUIGrid, MUIBox, MUITypography, tokens } from "@cobee/cobee-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CobeeButton from "app/components/CobeeButton";
import analytics from "app/segment";
import events from "app/segment/events";
import { translate as t } from "infrastructure/translate/localization";
import authClient from "app/auth/Auth";

export default function SubsidySectionHeader({
  benefitModel,
}: {
  benefitModel;
}) {
  const userId = authClient.getEmployeeId();
  const canCreateDelivery = benefitModel?.allowedBenefits?.length > 0;

  const handleCreateDeliveryPress = async () => {
    await analytics.track(
      events.createDelivery.name,
      {
        userId,
      },
      undefined,
      async () => {
        window.location.href = `${window.location.protocol}//${window.location.host}/v2/benefits/new-delivery/choose-type?compensation-plan=${benefitModel.id}`;
      }
    );
  };

  return (
    <MUIBox sx={{ maxWidth: "58.75rem", marginTop: "48px" }}>
      <MUIGrid container alignItems="center" justifyContent="space-between">
        <MUIGrid item>
          <MUITypography
            variant="h6"
            color={tokens.palette.grey[900]}
            sx={{
              fontSize: "16px !important",
            }}
          >
            {t("subsidy-section.title")}
          </MUITypography>
        </MUIGrid>
        <MUIGrid item>
          <CobeeButton
            aria-label="create delivery button"
            disabled={!canCreateDelivery}
            className="add-icon-style"
            onClick={handleCreateDeliveryPress}
          >
            <FontAwesomeIcon icon="plus" />
            <span style={{ margin: "0 15px 0" }}>
              {t("subsidy-section.create-delivery")}
            </span>
          </CobeeButton>
        </MUIGrid>
      </MUIGrid>
      <MUITypography color={tokens.palette.grey[700]} variant="body2" py={1}>
        {t("subsidy-section.description")}
      </MUITypography>
    </MUIBox>
  );
}
